import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

const watchEntityKeys = ['customShortcodes']

const useCustomShortcodes = (options = {}) => {
  const { entityKey, filters, performHttpRequests } = options

  const {
    owner_id: filterOwnerId,
    owner_type: filterOwnerType,
  } = filters || {}

  const {
    updatedEntities: { customShortcodes: customShortcodesUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { loading: loadingCustomShortcodes } = useReduxAction(
    'customShortcodes',
    'loadCustomShortcodes',
    {
      entityKey,
      ...filters,
    },
    [filters, performHttpRequests],
    {
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  const { customShortcodes } = useSelector(reduxState => reduxState.entities)

  const filteredCustomShortcodes = useMemo(() => {
    const filtered = Object.values(customShortcodes).filter((shortcode) => {
      const { owner_id, owner_type } = shortcode

      const matchOwnerId = matchFilterNumber(owner_id, filterOwnerId)
      const matchOwnerType = filterOwnerType ? owner_type === filterOwnerType : true

      return matchOwnerId && matchOwnerType
    })

    return sortArrayBy(filtered, 'asc', 'title')
  }, [customShortcodesUpdatedAt, JSON.stringify(filters)])

  const hasFilteredCustomShortcodes = !!filteredCustomShortcodes.length

  return {
    filteredCustomShortcodes,
    hasFilteredCustomShortcodes,
    loading: loadingCustomShortcodes,
  }
}

export default useCustomShortcodes
